var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ExpandLess, ExpandMore, MoreVert } from '@mui/icons-material';
import { Chip, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as MoreIconSvg } from '../../../assets/images/dots-vertical.svg';
import ActionMenuList from '../../../builderPackage/components/actionsMenuList';
import { DynamicCatalogBuilder } from '../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import InfiniteScroll from '../../../builderPackage/components/infiniteScroll/infiniteScroll';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { dateFormate } from '../../../utils/utils';
import { ContractSaleOrderKeys } from '../../contractSaleOrder/services/entity';
import { PDIChecPagingAPI } from '../services/apiCalls';
import { PDICheckKeys } from '../services/entity';
import ViewPDICheck from './viewPDICheck';
var PassedTab = function (props) {
    var _crud$ContractSaleOrd, _crud$ContractSaleOrd2, _getLocalStorageItem, _getLocalStorageItem2;
    var value = props.value;
    var crud = useAppSelector(function (state) { return state.crud; });
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var hasMore = !crud[ContractSaleOrderKeys.Paging] || ((_crud$ContractSaleOrd = crud[ContractSaleOrderKeys.Paging]) === null || _crud$ContractSaleOrd === void 0 || (_crud$ContractSaleOrd = _crud$ContractSaleOrd.data) === null || _crud$ContractSaleOrd === void 0 ? void 0 : _crud$ContractSaleOrd.length) < ((_crud$ContractSaleOrd2 = crud[ContractSaleOrderKeys.Paging]) === null || _crud$ContractSaleOrd2 === void 0 ? void 0 : _crud$ContractSaleOrd2.TotalCount);
    var userOrganizationID = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var parentOrganizationId = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    var shouldIncludeIdentityId = (value === null || value === void 0 ? void 0 : value.IdentityId) && value.IdentityId !== "all";
    var columns = [{
            field: 'DocumentNo',
            headerName: 'Document no.',
            flex: 1,
            minWidth: 150,
            sortable: false
        }, {
            field: 'CreatedOn',
            headerName: 'Document date',
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CreatedOn ? "".concat(dateFormate(row === null || row === void 0 ? void 0 : row.CreatedOn)) : '-'; }
        }, {
            field: 'ModelName',
            headerName: 'Vehicle model',
            flex: 1,
            minWidth: 150,
            sortable: false
        }, {
            field: 'SerialNo',
            headerName: 'Engine no.',
            flex: 1,
            minWidth: 150,
            sortable: false
        }, {
            field: 'PinNo',
            headerName: 'VIN no.',
            flex: 1,
            minWidth: 150,
            sortable: false
        }, {
            field: 'InspectorName',
            headerName: 'Service advisor',
            flex: 1,
            minWidth: 180,
            sortable: false,
            valueFormatter: function (val, row) {
                var _row$InspectorGivenNa, _row$InspectorFamilyN;
                return row !== null && row !== void 0 && row.InspectorGivenName || row !== null && row !== void 0 && row.InspectorFamilyName ? "".concat((_row$InspectorGivenNa = row === null || row === void 0 ? void 0 : row.InspectorGivenName) !== null && _row$InspectorGivenNa !== void 0 ? _row$InspectorGivenNa : ' ', "  ").concat((_row$InspectorFamilyN = row === null || row === void 0 ? void 0 : row.InspectorFamilyName) !== null && _row$InspectorFamilyN !== void 0 ? _row$InspectorFamilyN : ' ') : '-';
            }
        }, {
            field: 'TechnicianName',
            headerName: 'Technician',
            flex: 1,
            minWidth: 180,
            sortable: false,
            valueFormatter: function (val, row) {
                var _row$TechnicianGivenN, _row$TechnicianFamily;
                return row !== null && row !== void 0 && row.TechnicianGivenName || row !== null && row !== void 0 && row.TechnicianFamilyName ? "".concat((_row$TechnicianGivenN = row === null || row === void 0 ? void 0 : row.TechnicianGivenName) !== null && _row$TechnicianGivenN !== void 0 ? _row$TechnicianGivenN : ' ', "  ").concat((_row$TechnicianFamily = row === null || row === void 0 ? void 0 : row.TechnicianFamilyName) !== null && _row$TechnicianFamily !== void 0 ? _row$TechnicianFamily : ' ') : '-';
            }
        }, {
            field: 'StatusName',
            headerName: 'PDI Status',
            flex: 1,
            minWidth: 120,
            sortable: false,
            renderCell: function (params) {
                var _params$value;
                return /*#__PURE__*/ React.createElement(Chip, {
                    label: (_params$value = params === null || params === void 0 ? void 0 : params.value) !== null && _params$value !== void 0 ? _params$value : '-',
                    size: "small",
                    variant: "filled",
                    color: "success",
                    sx: {
                        borderRadius: 6,
                        px: 1,
                        fontWeight: 'medium',
                        fontSize: 12
                    }
                });
            }
        }, {
            type: 'actions',
            field: 'actions',
            headerName: 'Action',
            minWidth: 80,
            sortable: false,
            renderCell: function (params) {
                var _this = this;
                return /*#__PURE__*/ React.createElement(MoreIconSvg, {
                    color: "secondary.600",
                    onClick: function (e) { return __awaiter(_this, void 0, void 0, function () {
                        var res, res_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Menu',
                                        Component: ActionMenuList,
                                        containerProps: {
                                            anchorEl: e === null || e === void 0 ? void 0 : e.target,
                                            anchorOrigin: {
                                                vertical: 'center',
                                                horizontal: 'right'
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'right'
                                            }
                                        },
                                        componentProps: {
                                            items: [{
                                                    id: 'viewInvoice',
                                                    children: ["View"]
                                                }, {
                                                    id: 'PrintInvoice',
                                                    children: ["Print"]
                                                }, {
                                                    id: 'ShareInvoice',
                                                    children: ["Share"]
                                                }]
                                        }
                                    }))];
                                case 1:
                                    res = _a.sent();
                                    console.log('res Showsurface -- ', res);
                                    console.log('params --', params);
                                    if (!((res === null || res === void 0 ? void 0 : res.payload) === "viewInvoice")) return [3 /*break*/, 3];
                                    return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Drawer',
                                            Component: ViewPDICheck,
                                            containerProps: {
                                                PaperProps: {
                                                    sx: {
                                                        width: {
                                                            xs: '100%',
                                                            sm: '90%',
                                                            md: '70%'
                                                        }
                                                    }
                                                },
                                                anchor: isMobile ? 'bottom' : 'right'
                                            },
                                            componentProps: {
                                                data: params === null || params === void 0 ? void 0 : params.row
                                            }
                                        }))];
                                case 2:
                                    res_1 = _a.sent();
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); }
                });
            }
        }];
    var formData = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            onClick: function () { },
            contentProps: {
                spacing: 0.5
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    justifyContent: "space-between",
                    display: "flex",
                    alignItems: 'center',
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 8,
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection: 'column',
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "DocumentNo",
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium'
                                    },
                                    fontSize: 'base',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "OrderDate",
                                    valueGetter: function (val, row) { return val !== null && val !== void 0 && val.CreatedOn ? "".concat(dateFormate(val === null || val === void 0 ? void 0 : val.CreatedOn)) : '-'; },
                                    // label: cardData.docNo,
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'sm',
                                        fontWeight: 'medium',
                                        color: 'secondary.900'
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'normal'
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 4,
                            justifyContent: 'flex-end',
                            alignItems: 'baseline',
                            spacing: 1,
                            elements: [{
                                    type: FormItemTypes.Chip,
                                    name: 'StatusName',
                                    // value: cardData?.statusName,
                                    variant: 'outlined',
                                    size: 'small',
                                    columnSize: 0,
                                    color: 'success',
                                    sx: {
                                        borderRadius: '6px',
                                        fontSize: 'sm',
                                        fontWeight: 'medium'
                                    }
                                }, {
                                    type: FormItemTypes.IconButton,
                                    name: "menuIcon",
                                    color: 'secondary',
                                    size: 'small',
                                    children: /*#__PURE__*/ React.createElement(MoreVert, {
                                        color: "secondary"
                                    }),
                                    columnSize: 2,
                                    sx: {
                                        width: '18px',
                                        height: '18px'
                                    },
                                    onClick: function (e, formValues, api) { return __awaiter(void 0, void 0, void 0, function () {
                                        var action, res;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Menu',
                                                        containerProps: {
                                                            anchorEl: e.target.parentElement
                                                        },
                                                        Component: ActionMenuList,
                                                        componentProps: {
                                                            items: [{
                                                                    id: 'viewInvoice',
                                                                    children: ["View"]
                                                                }, {
                                                                    id: 'PrintInvoice',
                                                                    children: ["Print"]
                                                                }, {
                                                                    id: 'ShareInvoice',
                                                                    children: ["Share"]
                                                                }]
                                                        }
                                                    }))];
                                                case 1:
                                                    action = _a.sent();
                                                    if (!((action === null || action === void 0 ? void 0 : action.payload) === "viewInvoice")) return [3 /*break*/, 3];
                                                    return [4 /*yield*/, dispatch(showSurface({
                                                            type: 'Drawer',
                                                            Component: ViewPDICheck,
                                                            containerProps: {
                                                                PaperProps: {
                                                                    sx: {
                                                                        width: {
                                                                            xs: '100%',
                                                                            sm: '90%',
                                                                            md: '70%'
                                                                        },
                                                                        height: {
                                                                            xs: '90%'
                                                                        },
                                                                        borderRadius: "8px 8px 0 0"
                                                                    }
                                                                },
                                                                anchor: 'bottom'
                                                            },
                                                            componentProps: {
                                                                data: formValues
                                                            }
                                                        }))];
                                                case 2:
                                                    res = _a.sent();
                                                    _a.label = 3;
                                                case 3: return [2 /*return*/];
                                            }
                                        });
                                    }); }
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'expanded',
                    value: false,
                    containerProps: {
                        spacing: 0
                    },
                    summaryProps: {
                        sx: {
                            display: 'none'
                        }
                    },
                    summary: [],
                    detailPanelProps: {
                        spacing: 1,
                        p: 1.5,
                        rowSpacing: 0
                    },
                    sx: {
                        bgcolor: 'background.secondary',
                        border: 'none'
                    },
                    columnSize: 12,
                    setFieldProps: function (state, currValue) {
                        return {
                            type: this.type,
                            containerProps: {
                                my: currValue ? 1.5 : 0
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'Service advisor: ',
                                    columnSize: 12,
                                    fontSize: 'base',
                                    fontWeight: 'medium',
                                    valueGetter: function (val, row) {
                                        var _val$InspectorGivenNa, _val$InspectorFamilyN;
                                        return val !== null && val !== void 0 && val.InspectorGivenName || val !== null && val !== void 0 && val.InspectorFamilyName ? "".concat((_val$InspectorGivenNa = val === null || val === void 0 ? void 0 : val.InspectorGivenName) !== null && _val$InspectorGivenNa !== void 0 ? _val$InspectorGivenNa : ' ', "  ").concat((_val$InspectorFamilyN = val === null || val === void 0 ? void 0 : val.InspectorFamilyName) !== null && _val$InspectorFamilyN !== void 0 ? _val$InspectorFamilyN : ' ') : '-';
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        fontSize: 'sm',
                                        fontWeight: 'medium'
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'PinNo',
                                    label: 'Vin no.: ',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0,
                                        fontSize: 'sm',
                                        fontWeight: 'medium'
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'ModelName',
                                    label: 'Vehicle model no : ',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'Technician : ',
                                    fontSize: 'basde',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    valueGetter: function (val, row) {
                                        var _val$TechnicianGivenN, _val$TechnicianFamily;
                                        return val !== null && val !== void 0 && val.TechnicianGivenName || val !== null && val !== void 0 && val.TechnicianFamilyName ? "".concat((_val$TechnicianGivenN = val === null || val === void 0 ? void 0 : val.TechnicianGivenName) !== null && _val$TechnicianGivenN !== void 0 ? _val$TechnicianGivenN : ' ', "  ").concat((_val$TechnicianFamily = val === null || val === void 0 ? void 0 : val.TechnicianFamilyName) !== null && _val$TechnicianFamily !== void 0 ? _val$TechnicianFamily : ' ') : '-';
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        fontSize: 'sm',
                                        fontWeight: 'medium'
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }]
                        };
                    },
                    elements: []
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    justifyContent: 'end',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'expand-button',
                            columnSize: 0,
                            color: 'secondary',
                            size: 'small',
                            sx: {
                                p: 0,
                                fontSize: 'sm'
                            },
                            setFormState: function (formValues) {
                                return {
                                    expanded: !(formValues !== null && formValues !== void 0 && formValues.expanded)
                                };
                            },
                            setFieldProps: function (formValues) {
                                return {
                                    type: this.type,
                                    children: formValues !== null && formValues !== void 0 && formValues.expanded ? ['View less', /*#__PURE__*/ React.createElement(ExpandLess, null)] : ['View more', /*#__PURE__*/ React.createElement(ExpandMore, null)]
                                };
                            }
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, IS_DESKTOP ? /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        mode: "edit",
        columns: columns,
        getPagingData: PDIChecPagingAPI,
        pagingAPIKey: PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.Paging,
        pagingAPIRequest: _objectSpread(_objectSpread({
            OrganizationId: userOrganizationID,
            ParentOrganizationId: parentOrganizationId
        }, shouldIncludeIdentityId && {
            IdentityId: value.IdentityId
        }), {}, {
            Status: "Pass"
        })
    }) : /*#__PURE__*/ React.createElement(InfiniteScroll, {
        apiCall: PDIChecPagingAPI,
        apiKey: PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.Paging,
        apiRequest: _objectSpread(_objectSpread({
            OrganizationId: userOrganizationID,
            ParentOrganizationId: parentOrganizationId
        }, shouldIncludeIdentityId && {
            IdentityId: value.IdentityId
        }), {}, {
            // IdentityId: value?.IdentityId == "all" ? null : value?.IdentityId,  //for my view
            Status: "Pass"
        }),
        elements: formData,
        hasMore: hasMore,
        gridContainerProps: {
            spacing: 2
        },
        gridItemProps: {
            xs: 12
        }
    }));
};
export default PassedTab;
